import API_BASE from "./api";


export class ProductService {
    static async getProducts(filters = {}) {
        const queryParams = new URLSearchParams(filters).toString();
        const response = await fetch(`${API_BASE}/products${queryParams ? `?${queryParams}` : ''}`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();
        // console.log(data.data)
        if (!response.ok) {
            throw new Error(data.message || 'Failed to get products');
        }

        return data.data;
    }

    // Get single product by ID or slug
    static async getProductById(productIdentifier) {
        const response = await fetch(`${API_BASE}/products/${productIdentifier}`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();
        // console.log(data.data)
        if (!response.ok) {
            throw new Error(data.message || 'Failed to get product');
        }

        return data.data;
    }

    // Get product by slug specifically
    static async getProductBySlug(slug) {
        const response = await fetch(`${API_BASE}/products/slug/${slug}`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get product by slug');
        }

        return data.data;
    }
    // Get all products
    // static async getProducts(filters = {}) {
    //     const queryParams = new URLSearchParams(filters).toString();
    //     const response = await fetch(`${API_BASE}/products${queryParams ? `?${queryParams}` : ''}`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     });
    //
    //     const data = await response.json();
    //
    //     if (!response.ok) {
    //         throw new Error(data.message || 'Failed to get products');
    //     }
    //
    //     return data.data;
    // }
    //
    // // Get single product
    // static async getProductById(productId) {
    //     const response = await fetch(`${API_BASE}/products/${productId}`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     });
    //
    //     const data = await response.json();
    //     console.log(data)
    //     if (!response.ok) {
    //         throw new Error(data.message || 'Failed to get product');
    //     }
    //
    //     return data.data;
    // }

    // Get product variants
    static async getProductVariants(productId) {
        const response = await fetch(`${API_BASE}/products/${productId}/variants`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get product variants');
        }

        return data.data;
    }

    // Get product reviews
    static async getProductReviews(productId) {
        const response = await fetch(`${API_BASE}/products/${productId}/reviews`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get product reviews');
        }

        return data.data;
    }

    // Add product review
    static async addProductReview(productId, reviewData) {
        const response = await fetch(`${API_BASE}/products/${productId}/reviews`, {
            method: 'POST',
            body: JSON.stringify(reviewData),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to add review');
        }

        return data.data;
    }

    // Search products
    static async searchProducts(query, filters = {}) {
        const searchParams = new URLSearchParams({ q: query, ...filters });
        const response = await fetch(`${API_BASE}/products/search?${searchParams}`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to search products');
        }

        return data.data;
    }

    // Get categories
    // static async getCategories() {
    //     const response = await fetch(`${API_BASE}/products/categories`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     });
    //
    //     const data = await response.json();
    //
    //     if (!response.ok) {
    //         throw new Error(data.message || 'Failed to get categories');
    //     }
    //
    //     return data.data;
    // }

    // Get featured products
    // static async getFeaturedProducts() {
    //     const response = await fetch(`${API_BASE}/products/featured`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     });
    //
    //     const data = await response.json();
    //
    //     if (!response.ok) {
    //         throw new Error(data.message || 'Failed to get featured products');
    //     }
    //
    //     return data.data;
    // }

    // Get related products
    static async getRelatedProducts(productId) {
        const response = await fetch(`${API_BASE}/products/${productId}/related`, {
            method: 'GET',
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get related products');
        }

        return data.data;
    }
}